import React from 'react';
import {PropTypes} from 'prop-types';
import {observer} from 'mobx-react';

@observer
export class NewAppValidations extends React.Component {
  static propTypes = {
    store: PropTypes.object.isRequired,
    reRouteOnErrorClick: PropTypes.bool
  };

  static defaultProps = {
    reRouteOnErrorClick: true
  }

  constructor(props) {
    super(props);
    this.store = this.props.store;
  }

  onErrorLinkClick = (event, error) => {
    event.preventDefault();
    const path = this.props.reRouteOnErrorClick
      ? error.path
      : '';
    this.store.goToErrorField(error, path, this.store.masterStore.newAppData.saveId);
  }

  render() {
    const showErrorPanel = this.store.errorList.length && this.store.masterStore.masterStateProps.errorsAreDisplayed;
    return (<div
      className={`new-app-validations ${showErrorPanel
        ? 'show'
        : 'hide'}`}>
      <div className="container">
        <div className="card border-danger">
          <p className="card-header bg-danger text-white" aria-live="assertive" >
            <i className="icon icon-error red" aria-hidden></i>
            Please correct the fields below and submit again.
          </p>
          <ul className="card-body" aria-live="polite">
            {this.store.errorList.map((error, index) => {
                return (<li key={index}>
                  <a href={`#${error.field}`} className="as-p" onClick={(event) => this.onErrorLinkClick(event, error)}>
                    <span className="field-name">{error.label}:&nbsp;</span><span className="message">{error.error}</span>
                  </a>
                </li>)
              })
            }
          </ul>
        </div>
      </div>
    </div>);
  }
}
